import { Title } from "react-admin";
import "./MaintenanceDashboard.css";
import { ServiceReminders } from "./widgets/ServiceReminders";
import { ActiveDiagnosticErrors } from "./widgets/ActiveDiagnosticErrors";
import { UnresolvedDvirDefects } from "./widgets/UnresolvedDvirDefects";
import { useContext } from "react";
import { GridLayoutWidget, SelectedVehiclesFilterContext } from "./common";
import { GeometrisAlerts } from "./widgets/GeometrisAlerts";
import { Breadcrumb } from "./Breadcrumb";
import { TotalVehicles } from "./widgets/total-vehicles/TotalVehicles";
import { VehiclesCondition } from "./widgets/vehicles-condition/VehiclesCondition";
import { SelectedVehiclesSlide } from "./SelectedVehiclesSlide";

interface Props {}

const widgets: GridLayoutWidget[] = [
  {
    i: "totalVehicles",
    Widget: TotalVehicles,
    icon: "info",
    title: "resources.maintenance-dashboard.labels.totalActiveVehicles",
  },
  {
    i: "vehiclesCondition",
    Widget: VehiclesCondition,
    icon: "info",
    title: "Vehicles condition",
  },
  {
    i: "dvir",
    Widget: UnresolvedDvirDefects,
    icon: "error",
    title: "resources.maintenance-dashboard.labels.unresolvedDvirDefects",
  },
  {
    i: "maintenance",
    Widget: ServiceReminders,
    icon: "warning",
    title: "resources.maintenance-dashboard.labels.serviceReminders",
  },
  {
    i: "diag",
    Widget: ActiveDiagnosticErrors,
    icon: "error",
    title: "resources.maintenance-dashboard.labels.activeDiagnosticErrors",
  },
  {
    i: "geometrisAlerts",
    Widget: GeometrisAlerts,
    icon: "warning",
    title: "resources.maintenance-dashboard.labels.vehicleAlerts",
  },
];

export const MaintenanceDashboard = (props: Props) => {
  const context = useContext(SelectedVehiclesFilterContext);
  const sidebarVisible = !!context?.selectedFilter;
  return (
    <>
      <Title title={<Breadcrumb />} />
      <div className="assets-maintenance-dashboard">
        {widgets.map((x) => (
          <x.Widget key={x.i} icon={x.icon} title={x.title} />
        ))}
        {sidebarVisible ? <SelectedVehiclesSlide /> : null}
      </div>
    </>
  );
};
